/* BWH META — fold-ud (read more) + blød anchor-scroll.
   Deles af main-product TOC-blokken og anchor-sektionerne. */
(function () {
  if (window.__bwhMetaInit) return;
  window.__bwhMetaInit = true;

  function initReadmore(root) {
    var wraps = root.querySelectorAll('[data-bwh-meta-readmore]');
    Array.prototype.slice.call(wraps).forEach(function (wrap) {
      if (wrap.dataset.bwhInit === 'true') return;
      wrap.dataset.bwhInit = 'true';

      var body = wrap.querySelector('[data-bwh-meta-body]');
      var btn = wrap.querySelector('[data-bwh-meta-toggle]');
      var lbl = btn && btn.querySelector('[data-bwh-meta-label]');
      if (!body || !btn) return;

      // Hvis teksten ikke fylder mere end den foldede højde: skjul knappen helt
      if (body.scrollHeight <= body.clientHeight + 4) {
        btn.style.display = 'none';
        body.classList.remove('is-collapsed');
        return;
      }

      var more = btn.getAttribute('data-more') || '';
      var less = btn.getAttribute('data-less') || '';
      btn.addEventListener('click', function () {
        var expanded = body.classList.contains('is-expanded');
        if (expanded) {
          body.classList.remove('is-expanded');
          body.classList.add('is-collapsed');
          btn.setAttribute('aria-expanded', 'false');
          if (lbl) lbl.textContent = more;
        } else {
          body.classList.remove('is-collapsed');
          body.classList.add('is-expanded');
          btn.setAttribute('aria-expanded', 'true');
          if (lbl) lbl.textContent = less;
        }
      });
    });
  }

  function initTocLinks(root) {
    var links = root.querySelectorAll('[data-bwh-toc-link]');
    Array.prototype.slice.call(links).forEach(function (a) {
      if (a.dataset.bwhInit === 'true') return;
      a.dataset.bwhInit = 'true';

      a.addEventListener('click', function (e) {
        var hash = a.getAttribute('href');
        if (!hash || hash.charAt(0) !== '#') return;
        var target = document.getElementById(hash.slice(1));
        if (!target) return; // sektionen findes ikke (endnu) — lad browseren håndtere det
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', hash);
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initReadmore(root);
    initTocLinks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
